import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
// pkg/dist-src/index.js
import { Octokit } from "@octokit/core"; // pkg/dist-src/error-request.js

function errorRequest(_x, _x2, _x3, _x4) {
  return _errorRequest.apply(this, arguments);
} // pkg/dist-src/wrap-request.js


function _errorRequest() {
  _errorRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state, octokit, error, options) {
    var retries, retryAfter;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!error.request || !error.request.request)) {
              _context.next = 2;
              break;
            }

            throw error;

          case 2:
            if (!(error.status >= 400 && !state.doNotRetry.includes(error.status))) {
              _context.next = 6;
              break;
            }

            retries = options.request.retries != null ? options.request.retries : state.retries;
            retryAfter = Math.pow((options.request.retryCount || 0) + 1, 2);
            throw octokit.retry.retryRequest(error, retries, retryAfter);

          case 6:
            throw error;

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _errorRequest.apply(this, arguments);
}

import Bottleneck from "bottleneck/light";
import { RequestError } from "@octokit/request-error";

function wrapRequest(_x5, _x6, _x7, _x8) {
  return _wrapRequest.apply(this, arguments);
}

function _wrapRequest() {
  _wrapRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(state, octokit, request, options) {
    var limiter;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            limiter = new Bottleneck();
            limiter.on("failed", function (error, info) {
              var maxRetries = ~~error.request.request.retries;
              var after = ~~error.request.request.retryAfter;
              options.request.retryCount = info.retryCount + 1;

              if (maxRetries > info.retryCount) {
                return after * state.retryAfterBaseValue;
              }
            });
            return _context2.abrupt("return", limiter.schedule(requestWithGraphqlErrorHandling.bind(null, state, octokit, request), options));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _wrapRequest.apply(this, arguments);
}

function requestWithGraphqlErrorHandling(_x9, _x10, _x11, _x12) {
  return _requestWithGraphqlErrorHandling.apply(this, arguments);
} // pkg/dist-src/index.js


function _requestWithGraphqlErrorHandling() {
  _requestWithGraphqlErrorHandling = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(state, octokit, request, options) {
    var response, error;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return request(request, options);

          case 2:
            response = _context3.sent;

            if (!(response.data && response.data.errors && /Something went wrong while executing your query/.test(response.data.errors[0].message))) {
              _context3.next = 6;
              break;
            }

            error = new RequestError(response.data.errors[0].message, 500, {
              request: options,
              response: response
            });
            return _context3.abrupt("return", errorRequest(state, octokit, error, options));

          case 6:
            return _context3.abrupt("return", response);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _requestWithGraphqlErrorHandling.apply(this, arguments);
}

var VERSION = "6.0.1";

function retry(octokit, octokitOptions) {
  var state = Object.assign({
    enabled: true,
    retryAfterBaseValue: 1e3,
    doNotRetry: [400, 401, 403, 404, 422, 451],
    retries: 3
  }, octokitOptions.retry);

  if (state.enabled) {
    octokit.hook.error("request", errorRequest.bind(null, state, octokit));
    octokit.hook.wrap("request", wrapRequest.bind(null, state, octokit));
  }

  return {
    retry: {
      retryRequest: function retryRequest(error, retries, retryAfter) {
        error.request.request = Object.assign({}, error.request.request, {
          retries: retries,
          retryAfter: retryAfter
        });
        return error;
      }
    }
  };
}

retry.VERSION = VERSION;
export { VERSION, retry };